import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { NotificationPrefs } from "@/lib/types";

const KEY = ["me", "notification-prefs"];

export function useNotificationPrefs() {
  const qc = useQueryClient();
  const query = useQuery<NotificationPrefs>({
    queryKey: KEY,
    queryFn: () => api.getNotificationPrefs(),
    staleTime: 60_000,
  });
  const save = useMutation({
    mutationFn: (p: NotificationPrefs) =>
      api.updateNotificationPrefs({
        matrix: p.matrix,
        always_notify_directed: p.always_notify_directed,
      }),
    // Optimistic: write the new prefs to the cache immediately so a rapid second
    // toggle reads fresh state (no lost update / checkbox flip-back); roll back
    // on error, reconcile with the server response on success.
    onMutate: (p: NotificationPrefs) => {
      const prev = qc.getQueryData<NotificationPrefs>(KEY);
      qc.setQueryData(KEY, p);
      return { prev };
    },
    onError: (_e, _p, ctx) => {
      if (ctx?.prev) qc.setQueryData(KEY, ctx.prev);
    },
    onSuccess: (data) => qc.setQueryData(KEY, data),
  });
  return { query, save };
}
